import styled from "styled-components";
import Tag from "../Tag/Tag";

const Button = styled.button`
  background-color: ${props =>
    props.success ? "#5cb85c" : props.ghost ? "transparent" : "white"};
  color: ${props => (props.success || props.ghost ? "white" : false)};
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: ${props =>
    props.size === "xs"
      ? "3px 6px"
      : props.size === "sm"
        ? "3px 6px"
        : "8px 16px"};
  font-size: ${props => (props.size === "xs" ? "10px" : "")};
  width: ${props => (props.circle ? "48px" : false)};
  height: ${props => (props.circle ? "48px" : false)};
  border-radius: ${props => (props.circle ? "50%" : "3px")};

  &:hover {
    cursor: pointer;
    background-color: #eaeaea;
  }

  .fa-chevron-right {
    color: #777;
    position: relative;
    left: -4px;
    margin-right: 8px;
    transition: all 115ms;
  }

  &:hover .fa-chevron-right {
    color: #000;
    left: 0px;
  }

  ${Tag} {
    margin-left: 4px;
  }

  ${Tag}:first-child {
    margin-left: 8px;
  }

  div {
    display: flex;
    align-items: center;
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/UI/Button/Button.js